export function BudsHeader({ subtitle }: { subtitle?: string }) {
  return (
    <header className="relative mx-auto flex max-w-2xl flex-col items-center px-6 pt-10 pb-8 text-center">
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 mx-auto h-1 w-40 rounded-full opacity-90"
        style={{ background: 'var(--gradient-buds)' }}
      />
      <img
        src="/buds-logo.svg"
        alt="Buds"
        className="h-14 w-auto drop-shadow-sm"
      />
      {subtitle && (
        <p className="mt-3 text-sm font-medium tracking-wide text-buds-dark/70">
          {subtitle}
        </p>
      )}
    </header>
  );
}

/**
 * Wraps page content in a centered, max-width container so the embedded
 * UI doesn't sprawl across the full iframe width.
 */
export function PageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto min-h-screen w-full max-w-2xl px-4 pb-12 sm:px-6">
      {children}
    </div>
  );
}

export function BrandCard({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="rounded-2xl border border-buds-dark/5 bg-buds-surface shadow-sm">
      <div
        aria-hidden
        className="h-1 rounded-t-2xl"
        style={{ background: 'var(--gradient-buds)' }}
      />
      <div className="space-y-4 p-6 sm:p-7">
        {title && (
          <h2 className="text-lg font-semibold text-buds-dark">{title}</h2>
        )}
        {children}
      </div>
    </section>
  );
}
